import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { apiErrorMessage } from "@/lib/api-error";
import { DemoBanner } from "./DemoBanner";
import { useDemo } from "./DemoContext";
import { useDemoApi } from "./DemoProvider";

/**
 * The demo's chrome over the app: the banner with its reset, and arrival at "/" sent on to the books (or to the
 * landing page while the demo isn't built yet). Renders nothing outside a demo organisation.
 */
export function DemoChrome() {
  const { demo, refresh } = useDemo();
  const api = useDemoApi();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (demo && pathname === "/") navigate(demo.status === "Ready" ? "/books" : "/try", { replace: true });
  }, [demo, pathname, navigate]);

  if (!demo) return null;

  async function reset() {
    const { error } = await api.POST("/v1/demo/reset", {});
    if (error) {
      toast.error(apiErrorMessage(error, "Couldn't reset the demo."));
      return false;
    }
    refresh();
    navigate("/try");
    return true;
  }

  return <DemoBanner expiresAt={demo.expiresAt} onReset={reset} />;
}
